var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"static-page"},[_c('div',{staticClass:"static-inner"},[_c('router-link',{staticClass:"back-btn",attrs:{"to":"/"}},[_vm._v("← Back to Home")]),_c('article',{staticClass:"static-content"},[_c('h1',[_vm._v(_vm._s(_vm.page.title))]),_c('div',{domProps:{"innerHTML":_vm._s(_vm.page.content)}})])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }